<template>
  <div
    class="rounded p-2 mb-3"
    :class="{ 'border-gray-400 shadow': !downloadable, 'border-green-500 shadow-md': downloadable }">
    <div
      v-if="!edit"
      class="flex items-center justify-between">
      <div class="flex-col items-start justify-start mr-2">
        <div
          class="text-xs font-medium"
          :class="{ 'mb-1': !registered, 'mb-2': registered }">
          {{ email }}
        </div>
        <div
          v-if="!registered"
          class="text-2xs italic mb-2">
          (belum memiliki akun)
        </div>
        <div
          v-if="downloadable"
          class="leading-tight text-sm md:text-base font-semibold mb-2">
          {{ user != null ? user.name : name }}
        </div>
        <div
          v-else
          class="text-sm md:text-base font-semibold text-gray-600 mb-2">
          <span class="italic">NAMA TIDAK TERSEDIA</span>
        </div>
        <div class="text-sm font-medium md:text-sm">
          {{ major.name }}<span v-if="city"> - {{ city.name }}</span>
        </div>
      </div>
      <div class="flex items-center justify-between">
        <button
          v-if="editable"
          class="focus:outline-none active:shadow-outline disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 mr-3"
          :class="{
            'bg-blue-600 text-gray-100': !downloadable,
            'border border-blue-600 bg-gray-100 text-blue-600': downloadable,
          }"
          @click="edit = true">
          <svg
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><path d="M413.967 276.8c1.06-6.235 1.06-13.518 1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318c4.26-3.118 5.319-8.317 2.13-13.518L418.215 115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186 20.801c-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098c-5.318 0-9.577 4.164-10.637 8.318l-8.508 55.117c-12.767 5.2-24.464 12.482-36.171 20.801l-53.186-20.801c-5.319-2.071-10.638 0-12.767 4.164L49.1 187.365c-2.119 4.153-1.061 10.399 2.129 13.518L96.97 235.2c0 7.282-1.06 13.518-1.06 20.8s1.06 13.518 1.06 20.8l-44.668 34.318c-4.26 3.118-5.318 8.317-2.13 13.518L92.721 396.4c2.13 4.164 8.508 6.235 12.767 4.164l53.187-20.801c10.637 8.318 23.394 15.601 36.16 20.801l8.508 55.117c1.069 5.2 5.318 8.318 10.637 8.318h85.098c5.319 0 9.578-4.164 10.638-8.318l8.518-55.117c12.757-5.2 24.464-12.482 36.16-20.801l53.187 20.801c5.318 2.071 10.637 0 12.767-4.164l42.549-71.765c2.129-4.153 1.06-10.399-2.13-13.518l-46.8-34.317zm-158.499 52c-41.489 0-74.46-32.235-74.46-72.8s32.971-72.8 74.46-72.8 74.461 32.235 74.461 72.8-32.972 72.8-74.461 72.8z" /></svg>
        </button>
        <button
          v-if="!editable && false"
          class="bg-green-600 focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6 mr-3"
          @click="downloadCertificate()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="text-white fill-current"
            viewBox="0 0 512 512"><path d="M269,335.61q-6.33.47-12.78.47c-5.23,0-10.4-.24-15.51-.69a176.11,176.11,0,0,1-127.67-72.94,4,4,0,0,0-6.77.35l-72,129.4c-2.74,5-3.17,11-.28,15.88A16.78,16.78,0,0,0,48.22,416h78a15.28,15.28,0,0,1,13.62,7.33L178.5,488a16.26,16.26,0,0,0,13.75,8h0c5.94-.33,12.09-4.19,14.56-9.6l66.11-145.15A4,4,0,0,0,269,335.61Z" /><path d="M477.64,391.88,406.11,262.71a4,4,0,0,0-6.74-.36,176.5,176.5,0,0,1-78.31,61.42,16.09,16.09,0,0,0-8.72,8.25l-36.86,81.1a7.92,7.92,0,0,0,0,6.6l30.27,66.59c2.45,5.41,8.59,9.36,14.52,9.69h0a16.3,16.3,0,0,0,13.7-8.12L372.5,423.3c2.89-4.85,8.13-7.33,13.78-7.3h78.77c6.67,0,11.72-3.48,14-10A16.92,16.92,0,0,0,477.64,391.88Z" /><ellipse
              cx="256.26"
              cy="160"
              rx="48.01"
              ry="48" /><path d="M256.26,16c-79.42,0-144,64.59-144,144s64.61,144,144,144,144-64.6,144-144S335.67,16,256.26,16Zm0,224a80,80,0,1,1,80-80A80.1,80.1,0,0,1,256.26,240Z" /></svg>
        </button>
        <button
          v-if="false"
          :disabled="!downloadable"
          class="bg-green-600 focus:outline-none active:shadow-outline disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 shadow rounded-full p-1 w-6 h-6"
          @click="downloadTicket()">
          <svg
            class="text-white fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><path d="M416 199.5h-91.4V64H187.4v135.5H96l160 158.1 160-158.1zM96 402.8V448h320v-45.2H96z" /></svg>
        </button>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="edit"
        class="flex-col items-center justify-between">
        <div class="w-full mb-1">
          <label
            class="w-full text-xs md:text-base mb-1 block font-semibold"
            for="">E-mail Peserta <span class="text-red-500">*</span></label>
          <input
            v-model="newEmail"
            :disabled="registered"
            :class="{
              'border-red-500': false
            }"
            class="disabled:opacity-75 disabled:bg-gray-300 disabled:cursor-not-allowed w-full block focus:border-green-400 focus:outline-none bg-transparent border-b text-sm md:text-base p-2"
            type="email"
            @change="resetError()">
          <p
            v-if="errors['email']"
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            {{ errors['email'][0] }}
          </p>
          <p
            v-else
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            &nbsp;
          </p>
        </div>
        <div class="w-full mb-1">
          <label
            class="w-full text-xs md:text-base mb-1 block font-semibold"
            for="">Nama Peserta</label>
          <input
            v-model="newName"
            :disabled="registered"
            :class="{
              'border-red-500': false
            }"
            class="disabled:opacity-75 disabled:bg-gray-300 disabled:cursor-not-allowed w-full block focus:border-green-400 focus:outline-none bg-transparent border-b text-sm md:text-base p-2"
            type="email"
            @change="resetError()">
          <p
            v-if="errors['name']"
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            {{ errors['name'][0] }}
          </p>
          <p
            v-else
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            &nbsp;
          </p>
        </div>
        <div class="w-full mb-1">
          <!-- <label
            class="w-full text-xs md:text-base mb-1 block font-semibold"
            for="">Jurusan <span class="text-red-500">*</span></label>
          <select
            v-model="major_id"
            class="leading-normal w-full block focus:border-green-400 focus:outline-none focus:border-gray-500 bg-transparent border-b text-sm md:text-base appearance-none p-2"
            :class="{
              'border-red-500': false
            }"
            @change="resetError()">
            <option
              value=""
              disabled="disabled">
              Pilih Jurusan
            </option>
            <option
              v-for="item in $store.state.majors"
              :key="item.id"
              :value="item.id">
              {{ item.name }}
            </option>
          </select> -->
          <p
            v-if="errors['major_id']"
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            {{ errors['major_id'][0] }}
          </p>
          <p
            v-else
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            &nbsp;
          </p>
        </div>
        <div
          v-if="false"
          class="w-full">
          <label
            class="w-full text-xs md:text-base mb-1 block font-semibold"
            for="">Kota <span class="text-red-500">*</span></label>
          <select
            v-model="city_id"
            class="leading-normal w-full block focus:border-green-400 focus:outline-none focus:border-gray-500 bg-transparent border-b text-sm md:text-base appearance-none p-2"
            :class="{
              'border-red-500': false
            }"
            @change="resetError()">
            <option
              value=""
              disabled="disabled">
              Pilih Kota
            </option>
            <option
              v-for="item in $store.state.cities"
              :key="item.id"
              :value="item.id">
              {{ item.name }}
            </option>
          </select>
          <p
            v-if="errors['city_id']"
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            {{ errors['city_id'][0] }}
          </p>
          <p
            v-else
            class="text-2xs md:text-base p-2 pt-px text-red-500 mt-1 italic">
            &nbsp;
          </p>
        </div>
        <div class="flex items-center justify-end">
          <button
            class="bg-white text-blue-500 focus:outline-none active:shadow-outline active:text-blue-400 disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 border border-blue-500 shadow rounded-full w-6 h-6 mr-3"
            @click="closeEdit()">
            <svg
              class="fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"><path d="M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z" /><path d="M360 330.9L330.9 360 256 285.1 181.1 360 152 330.9l74.9-74.9-74.9-74.9 29.1-29.1 74.9 74.9 74.9-74.9 29.1 29.1-74.9 74.9z" /></svg>
          </button>
          <button
            class="bg-white text-green-600 focus:outline-none active:shadow-outline active:text-green-500 disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 border border-green-600 shadow rounded-full w-6 h-6"
            @click="updateUserProductDetail()">
            <svg
              class="fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"><path d="M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm-42.7 318.9L106.7 260.3l29.9-29.9 76.8 76.8 162.1-162.1 29.9 29.9-192.1 191.9z" /></svg>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      validator: (val) => true,
      default: null,
    },
    user: {
      validator: (val) => true,
      default: null,
    },
    name: {
      validator: (val) => true,
      default: null,
    },
    email: {
      validator: (val) => true,
      default: null,
    },
    city: {
      validator: (val) => true,
      default: null,
    },
    major: {
      validator: (val) => true,
      default: null,
    },
    ticketId: {
      validator: (val) => true,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
      newEmail: this.email,
      newName: this.user != null ? this.user.name : this.name,
      city_id: this.city ? this.city.id : null,
      major_id: this.major.id,
      errors: [],
    };
  },
  computed: {
    downloadable() {
      return this.user != null || this.name != null;
    },
    registered() {
      return this.user != null;
    },
    editable() {
      return this.ticketId == null;
    },
  },
  mounted() {
  },
  methods: {
    resetForm() {
      this.newEmail = this.email;
      this.newName = this.user != null ? this.user.name : this.name;
      this.city_id = this.city ? this.city.id : null;
      this.major_id = this.major.id;
    },
    closeEdit() {
      this.edit = false;
      this.resetError();
      this.resetForm();
    },
    resetError() {
      this.errors = [];
    },
    async updateUserProductDetail() {
      this.$store.commit('setLoading', true);

      try {
        await this.$store.dispatch('pushUpdateUserProductDetail', {
          id: this.id,
          email: this.newEmail,
          name: this.newName,
          city_id: this.city_id,
          major_id: this.major_id,
        });
        this.$forceUpdate();
        this.closeEdit();
      } catch (error) {
        this.$store.commit('setLoading', false);
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        } else {
          throw error;
        }
      }
      this.$store.commit('setLoading', false);
    },
    downloadTicket() {
      window.location.href = '/download-ticket/' + this.id;
    },
    downloadCertificate() {
      window.location.href = '/download-certificate/' + this.id;
    },
  },
}
</script>

<style>
    .fade-enter-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>